'use client'

import { useState, Fragment,useRef } from 'react'
import { Dialog, DialogPanel,  Transition, TransitionChild  } from '@headlessui/react'

export default function ModalVideo() {
  const [modalOpen, setModalOpen] = useState(true)
const videoRef = useRef(null)
  return (
    <div>

      <Transition show={modalOpen} as={Fragment} entered={() =>  videoRef.current?.play()}>
        <Dialog onClose={() => setModalOpen(false)}  initialFocus={videoRef}>

          {/* 2. The backdrop layer */}
          <TransitionChild
            as="div"
            className="fixed inset-0 z-[99999] bg-black bg-opacity-50 transition-opacity"
            enter="transition ease-out duration-200"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition ease-out duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            aria-hidden="true"
          />

          {/* 3. The modal video */}
          <TransitionChild
            as="div"
            className="fixed inset-0 z-[99999] flex p-6"
            enter="transition ease-out duration-300"
            enterFrom="opacity-0 scale-75"
            enterTo="opacity-100 scale-100"
            leave="transition ease-out duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-75"
          >
            <div className="max-w-8xl mx-auto h-full flex items-center">
              <DialogPanel className="w-full max-h-full rounded-8xl shadow-2xl aspect-video bg-black overflow-hidden">
                <video  ref={videoRef}  width="1920" height="1080" loop controls>
                  <source src="https://bkend-api.paperchip.world/videos/profile.mov" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </DialogPanel>
            </div>
          </TransitionChild>

        </Dialog>
      </Transition>

    </div>
  )
}